import React from 'react';

export default function FormWindow(props) {
    const { children, style } = props;

    return (
        <div style={style}>
            {children}
        </div>
    );
};

